import Slider from "rc-slider";
import React, { useEffect, useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from "react-select";
import { getTickerDetails, updateTickerDetails } from "../../../../../../actions/appsMoreAction";
import { TOAST_DISMISS, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS } from "../../../../../../utils";
import { useDispatch } from "react-redux";
import { closePricingModal } from "../../../../../../utils/close_modal";
import { refreshThemes } from "../../../../../../actions/firstRunAction";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import { Link } from "react-router-dom";

const Ticker = ({ fonts, onHide, show, bannerDetails }) => {
    const dispatch = useDispatch();
    const [tickerDetails, setTickerDetails] = useState({});
    const [tickerStatus, setTickerStatus] = useState()
    const [customStatus, setCustomStatus] = useState(1)
    const [tickerSpeed, setTickerSpeed] = useState();
    const [tickerPosition, setTickerPosition] = useState();
    const [tickerType, setTickerType] = useState()
    const [enableTicker, setEnableTicker] = useState()
    const [tickerId, setTickerId] = useState()
    const [heading, setHeading] = useState()
    const [content, setContent] = useState()
    //Heading font faimly
    const [fontStyleSelect, setFontStyleSelect] = useState([]);
    const [headingFontStyle, setHeadingFontStyle] = useState();
    const [headingFontSelect, setHeadingFontSelect] = useState([]);
    const [headingFontVar, setHeadingFontVar] = useState("");
    //Content font faimly
    const [contentFontStyle, setContentFontStyle] = useState("");
    //Content font variants
    const [contentFont_VarIndex, setContentFont_VarIndex] = useState(0)
    const [contentFontSelect, setContentFontSelect] = useState([]);
    const [contentFontVar, setContentFontVar] = useState("");

    const [headingFontColor, setHeadingFontColor] = useState("");
    const [headingBgColor, setHeadingBgColor] = useState("")
    const [contentFontColor, setConetntFontColor] = useState("");
    const [contentBgColor, setContentBgColor] = useState("")

    const [headingFontSize, setHeadingFontSize] = useState(0)
    const [contentFontSize, setContentFontSize] = useState(0)

    const [tickerSpeedSelect, setTickerSpeedSelect] = useState([{ value: 5, label: 'Slow' }, { value: 10, label: 'Medium' }, { value: 20, label: 'Fast' }])
    const [tickerPositionSelect, setTickerPositionSelect] = useState([{ value: 1, label: 'At top with full width' }, { value: 2, label: 'At bottom with full width' }])
    const [tickerHight, setTickerHight] = useState()
    const [headingVarIndex, setHeadingVarIndex] = useState(1)
    const [contentVarIndex, setContentVarIndex] = useState(1)

    useEffect(() => {
        getTickerDetails().then((response) => {
            const { responseCode, responseData } = response.data;
            TOAST_LOADING();
            if (responseCode == 200) {
                const { CustomTicker, tickerStatus } = responseData;
                TOAST_DISMISS();
                setTickerDetails(responseData);
                setTickerStatus(tickerStatus)
                if (tickerStatus) {
                    setTickerType(CustomTicker.tickerType)
                    setHeadingFontStyle(CustomTicker.title_css_font);
                    setHeadingFontVar(CustomTicker.title_font_varient)
                    setContentFontStyle(CustomTicker.subtitle_css_font)
                    setContentFontVar(CustomTicker.subtitle_font_varient)

                    setHeadingFontSize(CustomTicker.title_font_size)
                    setContentFontSize(CustomTicker.subTitle_font_size)

                    setHeading(CustomTicker.title);
                    setContent(CustomTicker.subTitle);
                    setHeadingFontColor(CustomTicker.title_font_color);
                    setHeadingBgColor(CustomTicker.title_backgroud_color);
                    setConetntFontColor(CustomTicker.subTitle_font_color);
                    setContentBgColor(CustomTicker.subTitle_backgroud_color);

                    setTickerSpeed(CustomTicker.ticker_speed !== undefined ? CustomTicker.ticker_speed : 10)
                    setTickerPosition(CustomTicker.ticker_position !== undefined ? CustomTicker.ticker_position : 2)
                    setTickerHight(CustomTicker.ticker_height)
                    setEnableTicker(CustomTicker.status)
                    setTickerId(CustomTicker.id)
                } else {
                    setCustomStatus(tickerStatus)
                    setHeadingFontStyle(`Nunito Sans`);
                    setHeadingFontVar(`regular`)
                    setContentFontStyle(`Nunito Sans`)
                    setContentFontVar(`regular`)
                    setHeadingFontSize(16)
                    setContentFontSize(16)
                    setTickerSpeed(10)
                    setTickerPosition(2)
                    setTickerHight(40)
                }
            }
        })

        let fontStyleSelectData = [{ label: `Default`, value: `Default`, font_id: 0 }];
        if (fonts &&
            fonts.length) {
            fonts.map((font, index) => {
                fontStyleSelectData.push({
                    label: (
                        <span key={font.family} style={{ fontFamily: `${font.family}` }} className={`sGFfonte-${font}`} >
                            {font.family}
                        </span>
                    ),
                    value: font.family,
                    font_id: font.id
                });
            })
        }
        setFontStyleSelect(fontStyleSelectData)
    }, [])
    useEffect(() => {
        if (fontStyleSelect && fontStyleSelect.length > 0) {
            let DefaultVariants = true
            fonts.map((font, index) => {
                if (String(font.family).toLowerCase() == String(headingFontStyle).toLowerCase()) {
                    onHeadingFontChange(fontStyleSelect[parseInt(index) + 1], DefaultVariants);
                }
                if (String(font.family).toLowerCase() == String(contentFontStyle).toLowerCase()) {
                    onContentFontChange(fontStyleSelect[parseInt(index) + 1], DefaultVariants)
                }
            })
        }
    }, [headingFontStyle]);

    const onHeadingFontChange = (e, DefaultVariants) => {
        setHeadingFontSelect(null);
        setHeadingFontStyle(e.label.key);
        if (!DefaultVariants) {
            setHeadingVarIndex(0)
        }
        var f = fonts.filter((font) => font.id === e.font_id)[0];
        if (f && JSON.parse(f.variants) && JSON.parse(f.variants).length) {
            if (!DefaultVariants) setHeadingFontVar(JSON.parse(f.variants)[0]) 
            f = JSON.parse(f.variants).map((f, i) => {
                return {
                    label: (
                        <span key={f} style={{ fontFamily: `${e.label.key}` }} id='fontVar-subtitle' className={`sGFfonte-${f}`}>
                            {f}
                        </span>
                    ), value: f, variants_id: i
                };
            });
            setHeadingFontSelect(f);
        } else {
            setHeadingFontSelect([{
                value: `None`,
                label: (<span key="None" id='fontVar-subtitle'>
                    None
                </span>)
            }])
            setHeadingFontVar('None')
        }
    };

    const onContentFontChange = (e, DefaultVariants) => {
        setContentFontSelect(null);
        setContentFontStyle(e.label.key);
        if (!DefaultVariants) {
            setContentVarIndex(0)
        }
        var f = fonts.filter((font) => font.id === e.font_id)[0];
        if (f && JSON.parse(f.variants) && JSON.parse(f.variants).length) {
            if (!DefaultVariants) setContentFontVar(JSON.parse(f.variants)[0])
            f = JSON.parse(f.variants).map((f, i) => {
                if (DefaultVariants) {
                    if (String(f).toLowerCase() == String(contentFontVar).toLowerCase()) {
                        setContentFont_VarIndex(i)
                    }
                } else {
                    setContentFont_VarIndex(0)
                }
                return {
                    label: (
                        <span key={f} style={{ fontFamily: `${e.label.key}` }} id='fontVar-subtitle' className={`sGFfonte-${f}`}>
                            {f}
                        </span>
                    ), value: f, variants_id: i
                };
            });
            setContentFontSelect(f);
        } else {
            setContentFont_VarIndex(0)
            setContentFontSelect([{
                value: `None`,
                label: (<span key="None" id='fontVar-subtitle'>
                    None
                </span>)
            }])
            setContentFontVar('None')
        }
    };

    const onChangeVariant = (e) => {
        setHeadingFontVar(e.value)
    }

    const onChangeContentVariant = (e) => {
        setContentFont_VarIndex(e.variants_id);
        setContentFontVar(e.value)
    }

    useEffect(() => {
        setTimeout(() => {
            window.$("#heading_fontColor").minicolors({
                control: "hue",
                defaultValue: headingFontColor,
                letterCase: "lowercase",
                position: "bottom left",
                change: onHeadingFontColor,
                theme: "bootstrap",
            });
            window.$("#heading_bgColor").minicolors({
                control: "hue",
                defaultValue: headingBgColor,
                letterCase: "lowercase",
                position: "bottom left",
                change: onHeadingBgColor,
                theme: "bootstrap",
            });
            window.$("#content_fontColor").minicolors({
                control: "hue",
                defaultValue: contentFontColor,
                letterCase: "lowercase",
                position: "bottom left",
                change: onContentFontColor,
                theme: "bootstrap",
            });
            window.$("#content_bgColor").minicolors({
                control: "hue",
                defaultValue: contentBgColor,
                letterCase: "lowercase",
                position: "bottom left",
                change: onContentBgColor,
                theme: "bootstrap",
            });
        }, 500)

        if (!customStatus) {
            setHeading(tickerType == 1 ? `Tomorrowland` : tickerType == 3 ? 'Sponsors' : heading);
            setContent(tickerType == 1 ? `Share your posts with #Tomorrowland19 and get featured on this screen.` : tickerType == 3 ? 'Powered By: Google • Hospitality Partner: Marriot • Food Partner: Subway • Fashion Partner: Nike • Social Partner: Taggbox' : tickerType == 2 ? ' Post your pictures with #Tomorrowland and get a chance to win free tickets to Tomorrowland 2019' : content);
            setHeadingFontColor(tickerType == 1 ? '#fff' : tickerType == 3 ? '#000' : headingFontColor);
            setHeadingBgColor(tickerType == 1 ? '#EB5D68' : tickerType == 3 ? '#fff' : headingBgColor);
            setConetntFontColor(tickerType == 1 ? '#fff' : tickerType == 2 ? '#fff' : tickerType == 3 ? '#fff' : contentFontColor);
            setContentBgColor(tickerType == 1 ? '#171717' : tickerType == 2 ? '#514d4d' : tickerType == 3 ? '#207077' : contentBgColor)
        }
    }, [tickerType, tickerStatus]);

    const onHeadingFontColor = (hex, opacity) => {
        if (!hex) return;
        if (opacity) hex += ", " + opacity;
        setHeadingFontColor(hex);
    };
    const onHeadingBgColor = (hex, opacity) => {
        if (!hex) return;
        if (opacity) hex += ", " + opacity;
        setHeadingBgColor(hex);
    };
    const onContentFontColor = (hex, opacity) => {
        if (!hex) return;
        if (opacity) hex += ", " + opacity;
        setConetntFontColor(hex);
    };
    const onContentBgColor = (hex, opacity) => {
        if (!hex) return;
        if (opacity) hex += ", " + opacity;
        setContentBgColor(hex);
    };

    const onApplyTicker = () => {

        let data = {
            title: heading,
            title_css_font: headingFontStyle,
            title_font_varient: headingFontVar,
            title_font_color: headingFontColor,
            title_backgroud_color: headingBgColor,
            title_font_size: headingFontSize ? headingFontSize : 1,
            title_link_font: headingFontStyle.replace(/ /g, "+"),

            subTitle: content,
            subtitle_css_font: contentFontStyle,
            subtitle_font_varient: contentFontVar,
            subTitle_font_color: contentFontColor,
            subTitle_backgroud_color: contentBgColor,
            subTitle_font_size: contentFontSize ? contentFontSize : 1,
            subtitle_link_font: contentFontStyle.replace(/ /g, "+"),

            ticker_height: tickerHight,
            ticker_speed: tickerSpeed,
            ticker_position: tickerPosition,

            status: enableTicker,
            owner: localStorage.getItem('ownerId'),
            tickerId: tickerId,
            tickerType: `${tickerType}`
        }

        if(!tickerStatus){
            TOAST_ERROR('Please select an option');
            return;
        }
        TOAST_LOADING()
        updateTickerDetails(data).then(res => {
            const { responseCode, responseData } = res.data
            if (responseCode == 200) {
                TOAST_SUCCESS('Ticker settings applied successfully.')
                onHide();
                closePricingModal(dispatch);
                dispatch(refreshThemes());
            }
        }).catch(res => {
            TOAST_ERROR(res.message)
            onHide()
        })
    }

    return (
        tickerDetails && Object.keys(tickerDetails).length ? <Modal
            show={show}
            onHide={() => { onHide() }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            {true ? <div className="modal-content">
                <div className="modal-header justify-content-between">
                    <h4 className="modal-title">Personalize Ticker</h4>
                    <Button variant="link" className="px-2" onClick={() => onHide()} data-bs-dismiss="modal" aria-label="Close" aria-hidden="true" >
                        <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'text-secondary fs-6'} />
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {!tickerStatus ? <div className="col-md-12 mt10" id="tickerTypePanel">
                            <h4 className="selectTicker">
                                Select ticker template
                            </h4>
                            <div className="chooseTicker">
                                <label>
                                    <input type="radio" className="tickerType" value="1" />
                                    <div className="frontTickers" onClick={() => { setTickerType(1); setTickerStatus(1); }}>
                                        <div className="frontTickerTitle"> Tomorrowland </div>
                                        <div className="frontTickerSubTitle">
                                            <marquee className="runmarquee" scrollamount="10">
                                                Share your posts with #Tomorrowland19 and get featured on this screen.
                                            </marquee>
                                        </div>
                                    </div>
                                </label>
                            </div>

                            <div className="chooseTicker">
                                <label>
                                    <input type="radio"  className="tickerType" value="2"
                                    />
                                    <div className="frontTickers" onClick={() => { setTickerType(2); setTickerStatus(1) }}>
                                        <div className="frontTickerSubTitle ticker2frontSubtitle">
                                            <marquee className="runmarquee" scrollamount="10">
                                                Post your pictures with #Tomorrowland and get a chance to win free tickets to Tomorrowland 2019
                                            </marquee>
                                        </div>
                                    </div>
                                </label>
                            </div>

                            <div className="chooseTicker">
                                <label>
                                    <input type="radio"  className="tickerType" value="3"
                                    />
                                    <div className="frontTickers tickertype3design" onClick={() => { setTickerType(3); setTickerStatus(1) }}>
                                        <div className="frontTickerTitle">
                                            Sponsors
                                        </div>
                                        <div className="frontTickerSubTitle">
                                            <marquee className="runmarquee" scrollamount="10">
                                                Powered By: Google • Hospitality Partner: Marriot • Food Partner: Subway • Fashion Partner: Nike • Social Partner: Taggbox
                                            </marquee>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <a href="#getBlogTicker" className="commanColor dBackdrop  absoluteRight tooltips" aria-hidden="true" title="Help" data-bs-placement="left" data-bs-toggle="modal" data-width="920px" tabindex="-1" style={{ bottom: "-5px" }}>
                                <span className="icon-question icons"></span>
                            </a>
                        </div> :
                            //design your picker
                            <div className="col-md-12" id="tickerDesignPanel" >
                                <div className="form-group mt10" id="tickerHeading">
                                    {tickerType !== 2 ? <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="control-label mb-2" htmlFor=""> Heading </label>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend"> <span className="input-group-text">  <FontAwesomeIcon type={'regular'} icon={'heading'} iconClass={'fs-5 text-secondary'} /> </span> </div>
                                                        <input className="form-control" value={heading} onChange={(e) => setHeading(e.target.value)} placeholder="#Heading" />
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label className="control-label mb-2" htmlFor="">
                                                        Font Style
                                                    </label>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            {fontStyleSelect && fontStyleSelect.length ? (
                                                                <><Select
                                                                    options={fontStyleSelect}
                                                                    defaultValue={fontStyleSelect[fontStyleSelect.findIndex((i) => i.value == headingFontStyle)]}
                                                                    onChange={(e) => onHeadingFontChange(e)}
                                                                    isSearchable={true}
                                                                /></>
                                                            ) : null}
                                                        </div>
                                                        <div className="col-6">
                                                            {headingFontSelect && headingFontSelect.length ? (
                                                                <Select
                                                                    options={headingFontSelect}
                                                                    defaultValue={headingFontSelect[headingFontSelect.findIndex((i) => i.value == headingFontVar)]} 
                                                                    value={headingFontSelect[headingFontSelect.findIndex((i) => i.value == headingFontVar)]} 
                                                                    onChange={(e) =>
                                                                        onChangeVariant(e)
                                                                    }
                                                                />
                                                            ) :
                                                                null
                                                            }
                                                        </div>
                                                    </div>

                                                    <input type="hidden" name="data[CustomTicker][title_link_font]" className="form-control" id="title_link_font"  />
                                                    <input type="hidden" name="data[CustomTicker][title_css_font]" className="form-control" id="title_css_font" />
                                                    <input type="hidden" name="data[CustomTicker][title_font_varient]" className="form-control" id="title_font_varient" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mt-0 mt-3">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <label className="control-label mb-2" htmlFor="">
                                                                Font Color
                                                            </label>
                                                            <input className="form-control miniColors init"
                                                                data-control="hue"
                                                                id="heading_fontColor"
                                                                type={"text"}
                                                                maxLength={7}
                                                                defaultValue={headingFontColor}
                                                                onChange={(e) =>
                                                                    setHeadingFontColor(e.target.value)
                                                                } />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="control-label mb-2" htmlFor="">
                                                                BG Color
                                                            </label>
                                                            <input className="form-control miniColors init"
                                                                data-control="hue"
                                                                id="heading_bgColor"
                                                                type={"text"}
                                                                maxLength={7}
                                                                defaultValue={headingBgColor}
                                                                onChange={(e) =>
                                                                    setHeadingBgColor(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="control-label mb-2" htmlFor="">
                                                                Font Size
                                                            </label>
                                                            <input className="form-control" type="number" max={40} min={0} value={headingFontSize} onChange={(e) => setHeadingFontSize(e.target.value < 41 && e.target.value > -1 ? e.target.value : headingFontSize)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null}
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label className="control-label mb-2" htmlFor="">
                                                        Content
                                                    </label>
                                                    <textarea rows={3} cols={5} className="form-control" value={content} onChange={(e) => setContent(e.target.value)} ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="row">

                                                <div className="col-md-12">
                                                    <label className="control-label mb-2" htmlFor="">
                                                        Font Style
                                                    </label>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            {fontStyleSelect && fontStyleSelect.length ? (
                                                                <><Select
                                                                    options={fontStyleSelect}
                                                                    defaultValue={fontStyleSelect[fontStyleSelect.findIndex((i) => i.value == contentFontStyle)]}
                                                                    onChange={(e) => onContentFontChange(e)}
                                                                    isSearchable={true}
                                                                /></>
                                                            ) : null}
                                                        </div>
                                                        <div className="col-6">
                                                            {contentFontSelect && contentFontSelect.length ? (
                                                                <Select
                                                                    options={contentFontSelect}
                                                                    defaultValue={contentFontSelect[contentFontSelect.findIndex((i) => i.value == contentFontVar)]} 
                                                                    value={contentFontSelect[contentFontSelect.findIndex((i) => i.value == contentFontVar)]} 
                                                                    onChange={(e) =>
                                                                        onChangeContentVariant(e)
                                                                    }
                                                                />
                                                            ) :
                                                                null
                                                            }
                                                        </div>
                                                    </div>
                                                    <input type="hidden" name="data[CustomTicker][subtitle_link_font]" className="form-control" id="subtitle_link_font"  />
                                                    <input type="hidden" name="data[CustomTicker][subtitle_css_font]" className="form-control" id="subtitle_css_font"  />
                                                    <input type="hidden" name="data[CustomTicker][subtitle_font_varient]" className="form-control" id="subtitle_font_varient" />
                                                    {/* </div> */}

                                                </div>
                                                <div className="mt-3">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <label className="control-label mb-2" htmlFor="">
                                                                Font Color
                                                            </label>
                                                            <input className="form-control miniColors init"
                                                                // placeholder="#fbfbfb"
                                                                data-control="hue"
                                                                id="content_fontColor"
                                                                type={"text"}
                                                                maxLength={7}
                                                                defaultValue={contentFontColor}
                                                                onChange={(e) =>
                                                                    setConetntFontColor(e.target.value)
                                                                } />
                                                        </div>
                                                        <div className="col-md-4 col-sm-4">
                                                            <label htmlFor="">
                                                                BG Color
                                                            </label>
                                                            <input className="form-control miniColors init"
                                                                data-control="hue"
                                                                id="content_bgColor"
                                                                type={"text"}
                                                                maxLength={7}
                                                                defaultValue={contentBgColor}
                                                                onChange={(e) =>
                                                                    setContentBgColor(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-md-4 col-sm-4">
                                                            <label htmlFor="">
                                                                Font Size
                                                            </label>
                                                            <input className="form-control pl10" type="number" min={1} max={30} value={contentFontSize} onChange={(e) => setContentFontSize(e.target.value < 41 && e.target.value > -1 ? e.target.value : contentFontSize)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="range-slider range-slider_ticker">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <label className="line-h-16">Ticker Height</label>
                                                    <p className="m-0">
                                                        <span htmlFor="data ticker_height" className="range-slider__value dataticker_height" data-range="tickerHeight01">
                                                            {tickerHight}
                                                        </span>px
                                                    </p>
                                                </div>
                                                <Slider
                                                    onChange={(event) => setTickerHight(parseInt(event))}
                                                    trackStyle={{ backgroundColor: "#ff4051" }} value={tickerHight} min={30} max={100} />
                                            </div>
                                            <span className="help-block">
                                            </span>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="">
                                                Ticker Speed
                                            </label>
                                            <div className="select-box w-100">
                                                <Select
                                                    className="selectpicker"
                                                    options={tickerSpeedSelect}
                                                    defaultValue={tickerSpeed ? tickerSpeedSelect[tickerSpeedSelect.findIndex((i) => i.value == tickerSpeed)] : tickerSpeedSelect[1]}
                                                    onChange={(e) => setTickerSpeed(e.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-5">
                                            <label htmlFor="">
                                                Ticker Position
                                            </label>
                                            <div className="input-group input-group-prepend">
                                                <span className="input-group-text">
                                                    <FontAwesomeIcon type={'regular'} icon={'up-down-left-right'} iconClass={'fs-5 text-secondary'} />
                                                </span>
                                                <Select className="selectpicker"
                                                    options={tickerPositionSelect}
                                                    defaultValue={tickerPosition ? tickerPositionSelect[tickerPositionSelect.findIndex((i) => i.value == tickerPosition)] : tickerPositionSelect[1]}
                                                    onChange={(e) => setTickerPosition(e.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="d-flex">
                                        <div className="me-5 d-flex">
                                            <label className="d-flex align-items-center mb-0" htmlFor="">
                                                <span className=" me-1">Enable Ticker</span>
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Enable this to display a ticker.</Tooltip>}>
                                                    <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5 text-secondary'} />
                                                </OverlayTrigger>
                                            </label>
                                        </div>

                                        <div className="toggleOnBut py-2">
                                            <span className="switch">
                                                <label className="m-0">
                                                    <input className="onoffswitch-checkbox updateStatus init" type="checkbox" onChange={(e) => setEnableTicker(!enableTicker)} checked={enableTicker} />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div id="tickerPreviewCard2" className="tickerPreCard pt-3" key={tickerSpeed}>
                                    <div className="tickerPreContent">
                                        {tickerType !== 2 ? <div className={`tickerTitlePreview ${tickerType === 3 ? 'ticker3TitlePreview' : ''}`} style={{ backgroundColor: `${headingBgColor}`, width: 'auto' }}>
                                            <h1 className={`m-0 sGFfonte-${headingFontVar}`} id="tickerTitle" style={{ fontWeight: '500', color: `${headingFontColor}`, fontSize: `${headingFontSize}px`, fontFamily: headingFontStyle, fontVariant: headingFontVar }}>
                                                {heading}
                                            </h1>
                                        </div> : null}
                                        <div className="tickerSubtitlePreview" style={{ backgroundColor: `${contentBgColor}`, height: tickerType === 3 ? '60px' : '60px', width: "auto" }}>
                                            <marquee className="runmarquee" id="ticker_speed" scrollamount={tickerSpeed ? tickerSpeed : 10}>
                                                <h2 className={`m-0 sGFfonte-${contentFontVar}`} id="tickerSubtitle" style={{ fontWeight: '500', color: `${contentFontColor}`, fontSize: `${contentFontSize}px`, fontFamily: contentFontStyle, fontVariant: contentFontVar }}>
                                                    {content}
                                                </h2>
                                            </marquee>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div>
                <div className="form-actions modal-footer">
                    <div className="d-flex align-items-center justify-content-end w-100 m-0">
                        <div className="card-toolbar">
                            <Button variant="secondary" onClick={() => setTickerStatus(0)} id="ticker_back" style={{ display: !tickerStatus ? `none` : '' }} className="me-2" >
                                Back
                            </Button>
                            <Button variant="primary" onClick={() => onApplyTicker()}>Apply Ticker</Button>
                            <OverlayTrigger placement="top" overlay={<Tooltip>Help</Tooltip>}>
                                <a href="https://vimeo.com/545391315/cfc0a6bc7d"
                                    className="ms-2 vid_play_btn lity_lightbox"
                                    data-support="https://taggbox.com/support/how-to-add-banner-in-your-taggbox-widget/"
                                    data-lity>
                                    <FontAwesomeIcon type={'regular'} icon={'circle-question'} iconClass={'fs-5 text-secondary'} />
                                </a>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
            </div>
                : <div className="modal-content">
                    upgrade popup
                </div>}
        </Modal> : null
    );
}

export default Ticker;